module.exports = "<div class=main-col> <span translate translate-values=\"{value: '{{view}}'}\"> feature_limits.view_unavailable </span> <p><a class=button href=/settings/plan translate>limit.upgrade</a></p> </div> ";


//////////////////
// WEBPACK FOOTER
// ./app/main/posts/views/post-view-unavailable.html
// module id = 784
// module chunks = 0